module.exports = __webpack_public_path__ + "img/professioneel-logo-personal-trainer-coaching-raise-the-bar-oudenaarde-nutrition-coach-3.b6fe69c1.png";